export default __webpack_public_path__ + "static/media/congrats.bb8da0a3.png";